import { Action, AsyncAction } from '../../../types/actions';
import { AddNewAdmin, GetAdmins, UpdateChannels } from '../../../connection/auth';
import { BLAdmin } from '../../../types/working-model';

export const GET_ADMINS = "GET_ADMINS";
export function getAdmins(token: string): AsyncAction {
    return {
        type: GET_ADMINS,
        promise: GetAdmins(token)
    };
}

export const UPDATE_PERMISSIONS = "UPDATE_PERMISSIONS";
export function updatePermissions(token: string, profile: BLAdmin): AsyncAction {
    return {
        type: UPDATE_PERMISSIONS,
        promise: UpdateChannels(token, profile.id, profile.channels)
    };
}

export const SET_WORKING_PERMISSIONS = "SET_WORKING_PERMISSIONS";
export function setWorkingPermissions(permissions: string[]): Action {
    return {
        type: SET_WORKING_PERMISSIONS,
        payload: permissions
    };
}

export const ADD_ADMIN = "ADD_ADMIN";
export function addAdmin(token: string, email: string, permissions: string[]): AsyncAction {
	return {
		type: ADD_ADMIN,
		promise: AddNewAdmin(token, email, permissions)
	};
}

export const REMOVE_ADMIN = "REMOVE_ADMIN";
export function removeAdmin(token: string, profile: BLAdmin): AsyncAction {
	return {
		type: REMOVE_ADMIN,
		promise: UpdateChannels(token, profile.id, profile.channels)
	};
}